import React, { useState, useEffect, useRef } from "react";
import DataTable from 'react-data-table-component';
import DataTableExtensions from "react-data-table-component-extensions";
import "react-data-table-component-extensions/dist/index.css";
import { Link, useLocation } from 'react-router-dom';

import { CSVLink, CSVDownload } from "react-csv";

import { api_crud_route, api_list_route, api_crud_base, endpoints } from './Config';

import { reqPOST, reqGET, reqDELETE } from '../../../Utils';
import { getTokenInfo } from '../../../UseToken';
import UseSidebar from '../../../UseSidebar';
import Hosts from '../../../Hosts'

import Loader from '../../Loader/Loader';

import Swal from 'sweetalert2'

import { language } from './Language';

export default function List() {
    const [, set_dados] = useState(null);    
    const type_active = useRef(null);
    const data_active = useRef(null);
    const export_csv = useRef(null);
    const temporada = useRef(null);
    const clubes = useRef(null);

    const [data, setData] = useState([]);
    const [isloading, setLoading] = useState(true);

	const [lang, set_lang] = useState('pt');

    const { pathname } = useLocation();
    const [, set_sidebar] = useState([])
    const [permissions, set_permissions] = useState({})

    const [refresh, setRefresh] = useState(0);

    const SEGURO_CODIGO = '015D535F5A';
    const SEGURO_OPCIONAL_CODIGO = '19343B51E1';

    const get_info = async (id_serch)  => {

        let temporada_aux = await reqGET(`${Hosts.SIMCore_API}/intranet/components/type/${getTokenInfo().companycode}/temporada`)
        if(Array.isArray(temporada_aux.data)) {
            let t_aux = temporada_aux.data.find(e => e.info.active)
            set_dados(temporada.current = t_aux);
        }

        let clubes_aux = await reqGET(`${Hosts.SIMCore_API}/entities/list/${getTokenInfo().companycode}/Clube`)
        if(Array.isArray(clubes_aux.data)) {
            set_dados(clubes.current = clubes_aux.data);
        }

        if(id_serch === undefined || id_serch === null || id_serch === '') {
            reqGET(api_list_route(getTokenInfo().companycode))
                .then(res => {
                    console.log(res.data)
                    setData(res.data);
                    set_dados(data_active.current = res.data)
                    setLoading(false)
                })
                .catch(() => 404)
        }
        else {
            reqGET(`${api_crud_route}/client/${getTokenInfo().companycode}/${id_serch}`)
            .then(res => {
                //console.log(res.data)
                setData(res.data);
                set_dados(data_active.current = res.data)
                // setLoading(false)
            })
            .catch(() => 404)
        }
    }

    let get_permissions = (e, sidebar) => {
        let handleSingleCheck = (e, sidebar) => {
            const name = e;

            let ver_submenu = (node) => {
                if (node.submenu.length !== 0) {

                    node.submenu.forEach(subitem => {

                        if (subitem.path === name) {
                            set_permissions({ edit: subitem.edit, view: true, remove: subitem.remove })
                        }
                        else {
                            ver_submenu(subitem)
                        }

                    })
                }
            }

            sidebar.forEach(node => {
                if(node.path === name && 0) {
                    set_permissions({ edit: node.edit, view: true, remove: node.remove })
                } else
                    ver_submenu(node)
            })
        }

        handleSingleCheck(e, sidebar)
    }

    useEffect(() => {

        set_dados(type_active.current = 'all')
        set_dados(data_active.current = [])
        set_dados(clubes.current = [])
        set_dados(export_csv.current = [])

        if(getTokenInfo().profile === 'Cliente') {
            get_info(getTokenInfo().id)
        }
        else {
            get_info('')
        }

        set_lang(localStorage.getItem('lang'))

        UseSidebar().getSidebar(getTokenInfo().profile)
            .then(v => {
                get_permissions(pathname, v)
                set_sidebar(v)
                // setLoading(false)
            });
    }, [pathname, refresh]);

    //APAGAR REGISTO
    function apagar(id) {

        Swal.fire({
			title: language[lang].delete_title,
			text: language[lang].delete_text,
			icon: 'question',
			showCancelButton: true,
			confirmButtonColor: '#0095e8',
			cancelButtonColor: '#d9214e',
			confirmButtonText: language[lang].delete_confirm,
			cancelButtonText: language[lang].delete_cancel
		})
		.then((result) => {
			if (result.isConfirmed) {
				reqDELETE(api_crud_route, { id: id })
					.then(res => {
						//props.history.push(endpoints.list);
					})
					.catch(error => console.log(error))
			}
		})
    }

    const devolver = (id) => {

        Swal.fire({
			title: language[lang].return_title,
			text: language[lang].return_text,
			icon: 'question',
			showCancelButton: true,
			confirmButtonColor: '#0095e8',
			cancelButtonColor: '#d9214e',
			confirmButtonText: language[lang].return_confirm,
			cancelButtonText: language[lang].return_cancel
		})
		.then((result) => {
			if (result.isConfirmed) {

                // Swal.fire('', 'id ' + id, 'info')
                // return

                reqPOST(`${api_crud_base}/estancia/anular`, {numencomenda: id})
                    .then(() => { 
                        window.location.reload();
                    })
                    .catch(() => Swal.fire(language[lang].return_error, '', 'info'))

			}
		})

    }

    const resend_order = async (id, id_pagamento, estado_pagamento) => {

        await Swal.fire({
            title: 'Confirmar pagamento',
            text: 'Tem a certeza que pretende confirmar o pagamento desta inscrição?',
            icon: 'question',
            showCancelButton: true,
            confirmButtonColor: '#0095e8',
            cancelButtonColor: '#d9214e',
            confirmButtonText: 'Continuar',
            cancelButtonText: 'Voltar'
        })
        .then(async (result) => {
            if (result.isConfirmed) {

                console.log('id', id)
                console.log('id_pagamento', id_pagamento)
                console.log('estado_pagamento', estado_pagamento)

                let body = {
                    key: id_pagamento,
                    status: 'success',
                    ref: '',
                    data: '',
                    response: JSON.stringify({
                        id: id_pagamento,
                        obj: {
                            response: {
                                id: "",
                                method: {
                                    type: "tb",
                                    status: "active"
                                }
                            }
                        },
                        companycode: getTokenInfo().companycode
                    })
                }

                await reqPOST(`${Hosts.SIMCore_API}/store/payment/notification/status/resend`, body)
                Swal.fire('', 'Pagamento confirmado com sucesso.', 'info')

                setRefresh(r => r + 1)

            }
        })

    }

    const change_type = (type) => {
        set_dados(type_active.current = type)

        let array = []
        let array_csv = []

        /*
        let first_row = [
            "identificador_apolice",
            "nome_segurado",
            "data_nascimento",
            "numero_identificacao",
            "clube",
            "funcao",
            "numero_federado",
            "opcao_apolice",
            "data_inscricao"
        ]
        array_csv.push(first_row)
        */

        data.forEach(el => {
            if(type === 'seguro') {
                if(el.info.pagamento_pendente !== undefined && el.info.pagamento_pendente !== null && parseInt(el.info.pagamento_pendente) === 1) {
                    if(el.info.inscricao_valida !== undefined && el.info.inscricao_valida !== null && el.info.inscricao_valida === true) {
                        if(el.info.flag_seguro === undefined || el.info.flag_seguro === null || el.info.flag_seguro !== true) {
                            array.push(el)

                            let d_nascimento = new Date(el.info.documento.user_info.birthday)
                            let d_inscricao = new Date(el.info.data)
                            
                            let el_csv = {
                                identificador_apolice: (el.info.documento.user_info.seguro_opcional === true ? SEGURO_OPCIONAL_CODIGO : SEGURO_CODIGO),
                                nome_segurado: el.info.documento.user_info.name,
                                data_nascimento: parseInt(d_nascimento.getDate()).toString().padStart(2, '0') + '-' + (parseInt(d_nascimento.getMonth() + 1)).toString().padStart(2, '0') + '-' + d_nascimento.getFullYear(),
                                numero_identificacao: el.info.documento.user_info.vat !== undefined && el.info.documento.user_info.vat !== null && el.info.documento.user_info.vat !== '' ? el.info.documento.user_info.vat : el.info.documento.user_info.numero_identificacao,
                                clube:  el.info.documento.user_info.clube,
                                funcao: el.info.documento.user_info.funcao,
                                numero_federado: el.info.documento.user_info.numero_licenca,
                                opcao_apolice: '',
                                data_inscricao: parseInt(d_inscricao.getDate()).toString().padStart(2, '0') + '-' + (parseInt(d_inscricao.getMonth() + 1)).toString().padStart(2, '0') + '-' + d_inscricao.getFullYear(),
                            }
                            array_csv.push(el_csv)
                            
                            /*
                            let new_row = [
                                (el.info.documento.user_info.seguro_opcional === true ? SEGURO_OPCIONAL_CODIGO : SEGURO_CODIGO).toString(),
                                el.info.documento.user_info.name.toString(),
                                (parseInt(d_nascimento.getDate()).toString().padStart(2, '0') + '-' + (parseInt(d_nascimento.getMonth() + 1)).toString().padStart(2, '0') + '-' + d_nascimento.getFullYear()).toString(),
                                (el.info.documento.user_info.vat !== undefined && el.info.documento.user_info.vat !== null && el.info.documento.user_info.vat !== '' ? el.info.documento.user_info.vat : el.info.documento.user_info.numero_identificacao).toString(),
                                el.info.documento.user_info.clube.toString(),
                                el.info.documento.user_info.funcao.toString(),
                                el.info.documento.user_info.numero_licenca.toString(),
                                "",
                                (parseInt(d_inscricao.getDate()).toString().padStart(2, '0') + '-' + (parseInt(d_inscricao.getMonth() + 1)).toString().padStart(2, '0') + '-' + d_inscricao.getFullYear()).toString(),
                            ]
                            array_csv.push(new_row)
                            */
                        }
                    }
                }
            }
            else {
                array.push(el)
            }
        })

        // console.log('array', array)
        // console.log('array_csv', array_csv)

        set_dados(data_active.current = array)
        set_dados(export_csv.current = array_csv)

    }

    const exportar_seguro = async () => {

        console.log('data_active.current', data_active.current)
        console.log('export_csv.current', export_csv.current)

        await reqPOST(`${Hosts.SIMCore_API}/federation/seguro/season/regist`, { companycode: getTokenInfo().companycode, dados: data_active.current })

        document.getElementById('btn_export_csv').click();
        // btn_export_csv

        Swal.fire('', 'Ficheiro exportado com sucesso.', 'info')
        setRefresh(r => r + 1)

    }

    const validate = async (row) => {

        await Swal.fire({
            title: 'Validar Inscrição',
            text: 'Tem a certeza que pretende validar esta inscrição?',
            icon: 'question',
            showCancelButton: true,
            confirmButtonColor: '#0095e8',
            cancelButtonColor: '#d9214e',
            confirmButtonText: 'Continuar',
            cancelButtonText: 'Voltar'
        })
        .then(async (result) => {
            if (result.isConfirmed) {

                console.log('clubes.current', clubes.current)
                let clube_aux = clubes.current.find(e => e.name === row.info.documento.user_info.clube)

                let body = { 
                    id: row.id, 
                    id_usado_para_gerar_pagamento: row.info.id_usado_para_gerar_pagamento, 
                    id_user: row.info.documento.user_info.id_user,
                    temporada: {
                        id: temporada.current.id,
                        name: temporada.current.info.name
                    },
                    clube: {
                        id: clube_aux.id,
                        name: clube_aux.name
                    },
                    companycode: row.info.companycode, 
                    total_documento: parseFloat(row.info.documento.total_documento)
                }

                await reqPOST(`${Hosts.SIMCore_API}/federation/validate/season/regist`, body)
                Swal.fire('', 'Inscrição validada com sucesso.', 'info')

                setRefresh(r => r + 1)

            }
        })

    }

    const columns = [
        {
            name: language[lang].field_n_encomenda,
            selector: 'id',
            style: { "font-family": 'Open Sans, sans-serif', "font-variant-numeric": 'tabular-nums'},
            sortable: true,
            right: true,
            minWidth: '100px',
            maxWidth: '5%',
        },
        {
            name: language[lang].field_date,
            selector: 'info.data',
            style: { "font-family": 'Open Sans, sans-serif', "font-variant-numeric": 'tabular-nums'},
            sortable: true,
            center: true,
            minWidth: '150px',
            maxWidth: '10%',
        },
        {
            name: language[lang].field_name,
            selector: 'info.documento.user_info.name',
            sortable: true,    
            wrap: true,
            left: true,
            minWidth: '200px',
            maxWidth: '53%',
        },
        {
            name: 'Licença',
            selector: 'info.documento.user_info.numero_licenca',
            style: { "font-family": 'Open Sans, sans-serif', "font-variant-numeric": 'tabular-nums'},
            sortable: true,
            right: true,
            minWidth: '100px',
            maxWidth: '5%',
        },
        {
            name: language[lang].field_total,
            selector: 'info.documento.total_documento',
            cell: row => 
                <span style={{fontFamily: 'Open Sans, sans-serif', fontVariantNumeric: "tabular-nums"}}>
                    {parseFloat(row.info.documento.total_documento).toFixed(2) + ' €'}
                </span>
            ,
            style: { "font-family": 'Open Sans, sans-serif', "font-variant-numeric": 'tabular-nums'},
            sortable: true,
            right: true,
            minWidth: '100px',
            maxWidth: '8%',
        },
        {
            name: language[lang].flag_seguro,
            selector: 'info.flag_seguro',
            cell: row => (
                row.info.flag_seguro === true ? 
                    <span className="badge rounded-0 bg-success"><i className="bi bi-check-lg text-white fs-4"></i></span> 
                : 
                    <span className="badge rounded-0 bg-warning"><i className="bi bi-exclamation-lg text-dark fs-4"></i></span> 
            ),
            sortable: false,
            center: true,
            minWidth: '100px',
            maxWidth: '8%',
        },
        {
            name: language[lang].field_inscricao_valida,
            selector: 'info.inscricao_valida',
            cell: row => (
                row.info.inscricao_valida === true ? 
                    <span className="badge rounded-0 bg-success"><i className="bi bi-check-lg text-white fs-4"></i></span> 
                : 
                    <span className="badge rounded-0 bg-warning"><i className="bi bi-exclamation-lg text-dark fs-4"></i></span> 
            ),
            sortable: false,
            center: true,
            minWidth: '100px',
            maxWidth: '8%',
        },
        {
            name: language[lang].field_pagamento_pendente,
            selector: 'info.pagamento_pendente',
            cell: row => (
                parseInt(row.info.pagamento_pendente) === 1 ? 
                    <span className="badge rounded-0 bg-success"><i className="bi bi-check-lg text-white fs-4"></i></span> 
                : 
                    parseInt(row.info.pagamento_pendente) === 2 ? 
                            <span className="badge rounded-0 bg-primary"><i className="bi bi-check-lg text-white fs-4"></i></span> 
                        : 
                            parseInt(row.info.pagamento_pendente) === 0 ? 
                                <span className="badge rounded-0 bg-warning"><i className="bi bi-exclamation-lg text-dark fs-4"></i></span> 
                            : 
                                parseInt(row.info.pagamento_pendente) === -2 ? 
                                    <span className="badge rounded-0 bg-secondary"><i className="bi bi-arrow-return-left text-white fs-4"></i></span>
                                :
                                    <span className="badge rounded-0 bg-danger"><i className="bi bi-x-lg text-white fs-4"></i></span>
            ),
            sortable: false,
            center: true,
            minWidth: '100px',
            maxWidth: '8%',
        },
        {
            name: '',
            right: true,
            export: false,
            print: false,
            minWidth: '150px',
            maxWidth: '10%',
            cell: row => 
                <span>
                    {
                    parseInt(row.info.pagamento_pendente) === 1 && false ? 
                        <button className="button button-delete d-none" onClick={() => devolver(row['id'])}>
                            <i className="bi bi-file-earmark-x"></i>
                        </button>
                    :
                        null
                    }
                    {
                    parseInt(row.info.pagamento_pendente) === 1 && row.info.inscricao_valida !== true ? 
                        <button className={"button button-view"} onClick={() => validate(row)} >
                            <i className="bi bi-check2"></i>
                        </button>
                    :
                        null
                    }
                    {
                    parseInt(row.info.pagamento_pendente) === 0 || parseInt(row.info.pagamento_pendente) === -1 ? 
                        <button className={"button button-view" + (parseInt(row['info']['pagamento_pendente']) === -1 ? '' : ' ')} onClick={() => resend_order(row['id'], row['info']['id_usado_para_gerar_pagamento'], row['info']['pagamento_pendente'])} >
                            <i className="bi bi-cash-coin"></i>
                        </button>
                    :
                        null
                    }

                    <Link className="button button-update button-view" to={{ pathname: endpoints.view, state: { item: row, operation: 'view' } }} replace>
                        <i className="bi bi-eye"></i>
                    </Link>
                </span>
        },
    ];

    const columns_colaboradores = [
        {
            name: language[lang].field_n_encomenda,
            selector: 'id',
            sortable: true,
            left: true,
            minWidth: '100px',
            maxWidth: '10%',
        },
        {
            name: language[lang].field_date,
            selector: 'info.data',
            sortable: true,
            center: true,
            minWidth: '100px',
            maxWidth: '10%',
        },
        {
            name: language[lang].field_name,
            selector: 'info.documento.user_info.name',
            sortable: true,
            left: true,
            minWidth: '200px',
            maxWidth: '50%',
        },
        {
            name: language[lang].field_pagamento_pendente,
            selector: 'info.pagamento_pendente',
            cell: row => (
                parseInt(row.info.pagamento_pendente) === 1 ? 
                    <span className="badge rounded-0 bg-success"><i className="bi bi-check-lg text-white fs-4"></i></span> 
                : 
                    parseInt(row.info.pagamento_pendente) === 2 ? 
                            <span className="badge rounded-0 bg-primary"><i className="bi bi-check-lg text-white fs-4"></i></span> 
                        : 
                            parseInt(row.info.pagamento_pendente) === 0 ? 
                                <span className="badge rounded-0 bg-warning"><i className="bi bi-exclamation-lg text-dark fs-4"></i></span> 
                            : 
                                parseInt(row.info.pagamento_pendente) === -2 ? 
                                    <span className="badge rounded-0 bg-secondary"><i className="bi bi-arrow-return-left text-white fs-4"></i></span>
                                :
                                    <span className="badge rounded-0 bg-danger"><i className="bi bi-x-lg text-white fs-4"></i></span>
            ),
            sortable: false,
            center: true,
            minWidth: '100px',
            maxWidth: '10%',
        },
        {
            name: 'Plataforma',
            selector: 'info.origin',
            sortable: true,
            center: true,
            minWidth: '100px',
            maxWidth: '10%',
        },
        {
            name: '',
            right: true,
            export: false,
            print: false,
            minWidth: '100px',
            maxWidth: '10%',
            cell: row => 
                <span>
                    <Link className="button button-update button-view" to={{ pathname: endpoints.view, state: { item: row, operation: 'view' } }} replace>
                        <i className="bi bi-eye"></i>
                    </Link>
                </span>
        }
    ];

    const defaultComponentOptions = {
        rowsPerPageText: language[lang].table_rows_per_page,
        rangeSeparatorText: language[lang].table_separator,
        noRowsPerPage: false,
        selectAllRowsItem: false,
        selectAllRowsItemText: language[lang].table_all,
    };

    const tableData = {
        columns: (getTokenInfo().profile === 'Gestor de Conteúdos' || getTokenInfo().profile === 'Administrador') ? columns : columns_colaboradores,
        data: data_active.current,
        filterPlaceholder: language[lang].filter_placeholder,
        export: false,
        print: false
    }

    return (isloading ?
        <Loader />
    :
        <main>
            <div className={`dash-cards header`}>
                <h2 className="dash-title">{language[lang].component_list}</h2>
                <p>{language[lang].component} / {language[lang].component_list}</p>
            </div>
        
            <div className={`dash-cards body`}>
                <div className="container">

                    <div className="card mb-5 mb-xl-8">
                        <div className="card-body">
                        
                            <div className="pb-10">
                                <div className="div-table">
                                    {
                                    permissions.edit ?
                                        <div className="table-header text-end">
                                            <Link className="btn btn-sm btn-secondary rounded-0 multi-item" to={{ pathname: endpoints.regist }}  >
                                                <span>{language[lang].add_new}</span>
                                            </Link>
                                        </div>
                                    :
                                        null
                                    }
                                    <div className="table-body">

                                        <div className="row">
                                            <div className="col-6 mb-3 d-flex">
                                                <div>
                                                    <button type="button" className={"btn btn-sm btn-outline-secondary rounded-pill me-2" + (type_active.current === 'all' ? ' active' : '') } onClick={() => change_type('all')} >Todos</button>
                                                </div>
                                                <div>
                                                    <button type="button" className={"btn btn-sm btn-outline-secondary rounded-pill me-2" + (type_active.current === 'seguro' ? ' active' : '') } onClick={() => change_type('seguro')} >Seguro</button>
                                                </div>
                                            </div>
                                            {
                                            type_active.current === 'seguro' && Array.isArray(export_csv.current) && export_csv.current.length > 0 ?
                                                <div className="col-6 mb-3 text-end">
                                                    <div className="row d-flex">
                                                        <div>
                                                            <button type="button" className={"btn btn-sm btn-primary rounded-0"} onClick={() => exportar_seguro()}>Exportar para o seguro</button>
                                                            <CSVLink id="btn_export_csv" data={export_csv.current} separator={";"} className="d-none"></CSVLink>
                                                        </div>
                                                    </div>
                                                </div>
                                            :
                                                null
                                            }
                                        </div>

                                        <DataTableExtensions {...tableData}>
                                            <DataTable
                                                noDataComponent={language[lang].table_empty}
                                                noHeader
                                                pagination
                                                exportHeaders
                                                paginationComponentOptions={defaultComponentOptions}
                                                paginationPerPage={25}
                                                paginationRowsPerPageOptions={[25, 50, 100]}
                                            />
                                        </DataTableExtensions>
                                    </div>
                                </div>
                            </div>
        
                        </div>
                    </div>
                </div>
            </div>
        </main>
    )
}